var path = 'import-student-data/import-student-data.html';
var html = "<div>\n    <h1>Set Up Clever</h1>\n    <tabs-menu saved-match=\"vm.savedMatch\"></tabs-menu>\n    <student-test-import></student-test-import>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/import-student-data/import-student-data.html
// module id = 62
// module chunks = 0